import { Button, FormControl, FormHelperText, InputLabel, MenuItem, Paper, Select, SelectChangeEvent, SelectProps, Stack, TextField, TextFieldProps, Typography, useMediaQuery, useTheme } from "@mui/material";
import { ChangeEvent, useContext, useEffect, useState } from "react";
import { Form, useNavigation } from "react-router-dom";
import LoadingContext from "../../context/LoadingContext";
import { FieldsArrayItem, ItemWithFields } from "../../types/fnProps";
import { Schema, ValidationError } from "yup";
import hasProperty from "../../vars/hasProperty";
import Tiptap from "../TipTap/Tiptap";
import { SimulatedEvent } from "../../types/SimulatedEvent";


const AddForm = ({ fields, fieldsArray, handleFormCompletion, schema, buttonText }: Partial<ItemWithFields> & { handleFormCompletion: (data: object) => void, schema: Schema<object>, buttonText?: string }) => {
    const { isLoading } = useContext(LoadingContext);
    const navigation = useNavigation();
    const [hasError, setHasError] = useState({});
    const [userFields, setUserFields] = useState(fields);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const theme = useTheme();
    const smMatch = useMediaQuery(theme.breakpoints.down('md'));

    useEffect(() => {
        setUserFields(fields)
    }, [fields]);

    useEffect(() => {
        const submissionStates = {
            submitting: true,
            loading: true,
            idle: false
        }
        setIsSubmitting(submissionStates[navigation.state]);
    }, [navigation.state]);


    function removeError(id: string) {

        setHasError(prev => ({ ...prev, [id]: '' }))
    }

    function handleInputChange(e: ChangeEvent<HTMLInputElement>): void;
    function handleInputChange(e: SelectChangeEvent<unknown>): void;
    function handleInputChange(e: SimulatedEvent): void;
    function handleInputChange(e: ChangeEvent<HTMLInputElement> | SelectChangeEvent<unknown> | SimulatedEvent) {

        setUserFields(prev => {
            return { ...prev, [e.target.name]: e.target.value }
        })
    }


    async function submitForm() {
        try {
            const validated = await schema.validate(userFields, { abortEarly: false });
            handleFormCompletion(validated);
        } catch (e) {
            console.log(e);
            if (e instanceof ValidationError && e.inner) {
                const errors = e.inner?.reduce((p, c) => {
                    return c.path ? { ...p, [c.path]: c.message, } : p;
                }, {});

                setHasError(errors);
            }
        }
    }

    return (
        <Paper sx={smMatch ? { mx: 0, my: 2, px: 1.5, py: 3 } : { mx: 2, my: 2, p: 5 }}>
            <Form method="post" id="contact-form">
                <Stack spacing={2}>
                    {fieldsArray && fieldsArray.map(({ id, label, type, multiline, placeholder, required, options }: FieldsArrayItem) => {
                        const props: TextFieldProps = {
                            id: id,
                            name: id,
                            type: type || 'text',
                            value: (userFields && hasProperty(userFields, id)) ? userFields[id] : '',
                            onChange: handleInputChange,
                            error: !!(hasProperty(hasError, id) && hasError[id]),
                            onFocus: (e) => removeError(id),
                            label: label,
                            size: 'small',
                            multiline: multiline,
                            variant: 'outlined',
                            placeholder,
                            required
                            // rows: 4
                        }
                        const selectProps: SelectProps = {
                            id: id,
                            name: id,
                            type: type || 'text',
                            value: (userFields && hasProperty(userFields, id)) ? userFields[id] : '',
                            onChange: handleInputChange,
                            error: !!(hasProperty(hasError, id) && hasError[id]),
                            onFocus: (e) => removeError(id),
                            label: label,
                            size: 'small',
                            multiline: multiline,
                            variant: 'outlined',
                            // rows: 4
                        }

                        return type === 'select'
                            ? <FormControl key={id}>
                                <InputLabel shrink>{label}</InputLabel>
                                <Select {...selectProps}>
                                    {options && options.map(option => {
                                        return option.type && option.type === 'label'
                                            ? <Typography key={option.value} variant="subtitle2" sx={{ px: 2, fontWeight: "bold", background: '#cccccc', borderBottom: '1px solid #000000', borderTop: '1px solid #000000' }}>
                                                {option.value}
                                            </Typography>
                                            : <MenuItem value={option.value} key={option.value}>{option.display || option.value}</MenuItem>
                                    })}
                                </Select>
                                <FormHelperText>{hasProperty(hasError, id) ? hasError[id] : ''}</FormHelperText>
                            </FormControl>
                            : type === 'rich-text'
                                ? <FormControl key={id} error={!!(hasProperty(hasError, id) && hasError[id])}>
                                    <InputLabel shrink>{label}</InputLabel>
                                    <Tiptap content={(userFields && hasProperty(userFields, id)) ? userFields[id] : ''} onChange={handleInputChange} inputName={id} onFocus={() => removeError(id)} />
                                    <FormHelperText>{hasProperty(hasError, id) ? hasError[id] : ''}</FormHelperText>
                                </FormControl>
                                : <TextField {...props} helperText={hasProperty(hasError, id) ? hasError[id] : ''} InputLabelProps={{ shrink: true }} key={id} />
                    })}
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={isSubmitting || isLoading}
                        name="intent"
                        value="preflight"
                        onClick={submitForm}
                    >
                        {buttonText || 'Submit'}
                    </Button>
                </Stack>
            </Form>
        </Paper>
    );
};

export default AddForm;